import cn from "classnames";
import { ReactCountryFlagProps } from "react-country-flag";
import { isCryptoCode } from "shared/src/cryptoUtils";
import { CryptoFlag } from "shared/src/CryptoFlag";
import { FiatFlag } from "shared/src/FiatFlag";

type CountryFlagProps = ReactCountryFlagProps;

export const CountryFlag = ({
  countryCode,
  className,
  ...props
}: CountryFlagProps) => {
  return isCryptoCode(countryCode) ? (
    <CryptoFlag
      cryptoCode={countryCode}
      className={cn("rounded-full", className)}
    />
  ) : (
    <FiatFlag {...props} countryCode={countryCode} className={className} />
  );
};
